import { createAsyncThunk } from "@reduxjs/toolkit";

import { getAnonymousUserToken } from "@/models";
import { AppState } from "@/redux/store/store";

export const fetchAnonymousUser = createAsyncThunk(
  "anonymousUser/fetchAnonymousUser",
  async (
    params: Partial<{ config: object }>,
    { getState, rejectWithValue }
  ) => {
    try {
      const { config } = params;
      const { adapter } = getState() as AppState;
      return await getAnonymousUserToken(adapter.adapter.baseUrl, config ?? {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
